import React from 'react';

const MultiEditModal = ({
                            showModal,
                            setShowModal,
                            selectedItems,
                            setSelectedItems,
                            categoryOptions,
                            subCategoryOptions,
                            subCategory2Options,
                            subCategory3Options,
                            floorOptions,
                            roomOptions,
                            siteLayout,
                            onSave,
                            isLoading,
                            title = "Edit Multiple Assets"
                        }) => {
    const handleFieldUpdate = (assetId, field, value) => {
        setSelectedItems((prevItems) =>
            prevItems.map((item) => {
                if (item.assetId === assetId) {
                    const updatedItem = { ...item, [field]: value };

                    // Reset dependent fields when parent changes
                    if (field === "category") {
                        updatedItem.subCategory = "";
                        updatedItem.subCategory2 = "";
                        updatedItem.subCategory3 = "";
                    } else if (field === "subCategory") {
                        updatedItem.subCategory2 = "";
                        updatedItem.subCategory3 = "";
                    } else if (field === "subCategory2") {
                        updatedItem.subCategory3 = "";
                    } else if (field === "position") {
                        updatedItem.floor = "";
                        updatedItem.room = "";
                    } else if (field === "floor") {
                        updatedItem.room = "";
                    }

                    return updatedItem;
                }
                return item;
            })
        );
    };

    const orderMap = {
        Basement: 1,
        "Ground Floor": 2,
        "1st Floor": 3,
        "2nd Floor": 4,
        "3rd Floor": 5,
        "4th Floor": 6,
        "5th Floor": 7,
        "6th Floor": 8,
        "7th Floor": 9,
        "8th Floor": 10,
        "9th Floor": 11,
        "10th Floor": 12,
        Vertical: 13,
    };

    const getFloorsForAsset = (asset) => {
        if (!asset?.position) return [];
        if (Array.isArray(siteLayout) && siteLayout.length > 0) {
            const positionNode = siteLayout.find((node) => node?.nodeName === asset.position);
            if (!positionNode?.id) return [];
            return siteLayout
                .filter((node) => node?.nodeType === "floor" && node?.parentNode === positionNode.id)
                .sort((a, b) => {
                    const orderA = orderMap[a?.nodeName] || 999;
                    const orderB = orderMap[b?.nodeName] || 999;
                    return orderA - orderB;
                });
        }
        return Array.isArray(floorOptions) ? floorOptions : [];
    };

    const getRoomsForAsset = (asset, floorsForAsset) => {
        if (!asset?.floor) return [];
        if (Array.isArray(siteLayout) && siteLayout.length > 0) {
            const selectedFloor = (floorsForAsset || []).find((f) => f?.nodeName === asset.floor);
            if (!selectedFloor?.id) return [];
            return siteLayout.filter(
                (node) => node?.nodeType === "room" && node?.parentNode === selectedFloor.id
            );
        }

        const selectedFloor = (floorsForAsset || []).find((f) => f?.nodeName === asset.floor);
        if (!selectedFloor?.id) return [];
        return (Array.isArray(roomOptions) ? roomOptions : []).filter(
            (node) => node?.parentNode === selectedFloor.id
        );
    };

    return (
        <div
            className="modal fade show"
            style={{ display: showModal ? "block" : "none", backgroundColor: "rgba(86, 86, 86, 0.2)" }}
        >
            <div
                className="modal-dialog modal-dialog-scrollable"
                style={{ width: "90vw", maxWidth: "90vw" }}
            >
                <div
                    className="modal-content"
                    style={{ minHeight: "90vh", minWidth: "90vw" }}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {title} ({selectedItems.length} selected)
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setShowModal(false)}
                            disabled={isLoading}
                        ></button>
                    </div>
                    <div className="modal-body p-0">
                        <div className="table-responsive" style={{ maxHeight: "70vh" }}>
                            <table className="table table-hover mb-0">
                                <thead className="sticky-top bg-light">
                                <tr>
                                    <th style={{ width: "100px", minWidth: "100px" }}>
                                        Asset ID
                                    </th>
                                    <th style={{ width: "400px", minWidth: "400px" }}>
                                        Asset Name
                                    </th>
                                    <th style={{ width: "50px", minWidth: "50px" }}>
                                        Manufacturer
                                    </th>
                                    <th style={{ width: "50px", minWidth: "50px" }}>
                                        Category
                                    </th>
                                    <th style={{ width: "200px", minWidth: "200px" }}>
                                        Sub Category
                                    </th>
                                    <th style={{ width: "200px", minWidth: "200px" }}>
                                        Sub Cat 2
                                    </th>
                                    <th style={{ width: "200px", minWidth: "200px" }}>
                                        Sub Cat 3
                                    </th>
                                    <th style={{ width: "100px", minWidth: "100px" }}>
                                        Position
                                    </th>
                                    <th style={{ width: "200px", minWidth: "200px" }}>
                                        Floor
                                    </th>
                                    <th style={{ width: "200px", minWidth: "200px" }}>
                                        Room
                                    </th>
                                    <th style={{ width: "50px", minWidth: "50px" }}>
                                        Power Output (KW)
                                    </th>
                                </tr>
                                </thead>
                                <tbody style={{ overflowY: "auto" }}>
                                {selectedItems.map((asset) => {
                                    const floorsForAsset = getFloorsForAsset(asset);
                                    const roomsForAsset = getRoomsForAsset(asset, floorsForAsset);

                                    const subCategoryList = subCategoryOptions?.filter(
                                        (itm) => itm.attribite1 === asset.category
                                    ) || [];
                                    const subCategory2List = subCategory2Options?.filter(
                                        (itm) => itm.attribite1 === asset.subCategory
                                    ) || [];
                                    const subCategory3List = subCategory3Options?.filter(
                                        (itm) => itm.attribite1 === asset.subCategory2
                                    ) || [];

                                    return (
                                        <tr key={asset.assetId}>
                                            <td style={{ width: "200px", minWidth: "200px" }}>
                                                {asset.assetId}
                                            </td>
                                            <td style={{ width: "200px", minWidth: "200px" }}>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={asset.assetName || ""}
                                                    onChange={(e) =>
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "assetName",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={asset.manufacturer || ""}
                                                    onChange={(e) =>
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "manufacturer",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={asset.category || ""}
                                                    onChange={(e) => {
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "category",
                                                            e.target.value
                                                        );
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory",
                                                            ""
                                                        );
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory2",
                                                            ""
                                                        );
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory3",
                                                            ""
                                                        );
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    {categoryOptions?.map((opt) => (
                                                        <option
                                                            key={opt.lovValue}
                                                            value={opt.lovValue}
                                                        >
                                                            {opt.lovValue}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={asset.subCategory || ""}
                                                    onChange={(e) => {
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory",
                                                            e.target.value
                                                        );
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory2",
                                                            ""
                                                        );
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory3",
                                                            ""
                                                        );
                                                    }}
                                                    disabled={!asset.category}
                                                >
                                                    <option value="">Select</option>
                                                    {subCategoryList.map((opt) => (
                                                        <option
                                                            key={opt.lovValue}
                                                            value={opt.lovValue}
                                                        >
                                                            {opt.lovValue}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={asset.subCategory2 || ""}
                                                    onChange={(e) => {
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory2",
                                                            e.target.value
                                                        );
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory3",
                                                            ""
                                                        );
                                                    }}
                                                    disabled={!asset.subCategory}
                                                >
                                                    <option value="">Select</option>
                                                    {subCategory2List.map((opt) => (
                                                        <option
                                                            key={opt.lovValue}
                                                            value={opt.lovValue}
                                                        >
                                                            {opt.lovValue}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={asset.subCategory3 || ""}
                                                    onChange={(e) =>
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "subCategory3",
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={!asset.subCategory2}
                                                >
                                                    <option value="">Select</option>
                                                    {subCategory3List.map((opt) => (
                                                        <option
                                                            key={opt.lovValue}
                                                            value={opt.lovValue}
                                                        >
                                                            {opt.lovValue}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={asset.position || ""}
                                                    onChange={(e) => {
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "position",
                                                            e.target.value
                                                        );
                                                        handleFieldUpdate(asset.assetId, "floor", "");
                                                        handleFieldUpdate(asset.assetId, "room", "");
                                                    }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Interior">Interior</option>
                                                    <option value="Exterior">Exterior</option>
                                                </select>
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={asset.floor || ""}
                                                    onChange={(e) => {
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "floor",
                                                            e.target.value
                                                        );
                                                        handleFieldUpdate(asset.assetId, "room", "");
                                                    }}
                                                    disabled={!asset.position}
                                                >
                                                    <option value="">Select</option>
                                                    {floorsForAsset?.map((node) => (
                                                        <option
                                                            key={node.nodeName}
                                                            value={node.nodeName}
                                                        >
                                                            {node.nodeName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={asset.room || ""}
                                                    onChange={(e) =>
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "room",
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={!asset.floor}
                                                >
                                                    <option value="">Select</option>
                                                    {roomsForAsset?.map((node) => (
                                                            <option
                                                                key={node.nodeName}
                                                                value={node.nodeName}
                                                            >
                                                                {node.nodeName}
                                                            </option>
                                                        ))}
                                                </select>
                                            </td>
                                            <td style={{ width: "300px", minWidth: "300px" }}>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={asset.powerOutput || ""}
                                                    onChange={(e) =>
                                                        handleFieldUpdate(
                                                            asset.assetId,
                                                            "powerOutput",
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer d-flex justify-content-between">
                        <div>
                            <button
                                type="button"
                                className="btn btn-outline-secondary me-2"
                                onClick={() => {
                                    if (
                                        window.confirm(
                                            "Are you sure you want to discard all changes?"
                                        )
                                    ) {
                                        setShowModal(false);
                                    }
                                }}
                                disabled={isLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={onSave}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Saving...
                                    </>
                                ) : (
                                    `Save ${selectedItems.length} Assets`
                                )}
                            </button>
                        </div>
                        <div className="text-muted small">
                            Showing {selectedItems.length} of {selectedItems.length}{" "}
                            selected assets
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MultiEditModal;